export const onceRequest = action => {
  let sending = false;

  if (typeof action != 'function') {
    throw new TypeError('Expected a function');
  }

  return function() {
    if (sending) {
      return;
    }

    sending = true;

    Promise.resolve(action.apply(this, arguments)).finally(() => {
      sending = false;
    });
  };
};
